function invoiceLines(content) {
  if (Array.isArray(content.invoiceLines)) return content.invoiceLines
  return content.goodsName ? [{ goodsName: content.goodsName, model: content.model || '', quantity: content.quantity, unit: '', productId: content.productId, productCode: content.productCode, productName: content.productName, productVersion: content.productVersion }] : []
}
const same = (a,b) => JSON.stringify(a) === JSON.stringify(b)
function mergeInvoiceDefaults(content, defaults, previous, started) {
  const next = { ...content }, old = previous || {}, initial = started || content
  ;['buyerName','invoiceInformation'].forEach(key => {
    if (defaults[key] && same(content[key],initial[key]) && (!String(content[key] || '').trim() || same(content[key],old[key]))) next[key] = defaults[key]
  })
  const rows = invoiceLines(content)
  if (same(rows,invoiceLines(initial)) && (!rows.length || same(rows,old.invoiceLines))) next.invoiceLines = (defaults.invoiceLines || []).map(x => ({ ...x }))
  else {
    const sources = new Set((defaults.invoiceLines || []).map(x => String(x.sourceContractItemId)))
    next.invoiceLines = rows.map(row => ({ ...row, sourceContractItemId: sources.has(String(row.sourceContractItemId)) ? row.sourceContractItemId : null }))
  }
  return next
}
function emptyInvoiceLine() { return { goodsName: '', model: '', quantity: null, unit: '' } }
function detachInvoiceSources(content) { return { ...content, invoiceLines: invoiceLines(content).map(row => ({ ...row, sourceContractItemId: null })) } }
module.exports = { invoiceLines, mergeInvoiceDefaults, emptyInvoiceLine, detachInvoiceSources }
